/** Copyright (C) 2023 Trend Micro Inc. All rights reserved. */

import { RUNTIME_ENV_VITE_IS_DEV } from '@constants/viteEnv'

export const isProd = !RUNTIME_ENV_VITE_IS_DEV && NODE_ENV === 'production'
export const isDev = !isProd
export const isLocal =
  typeof window !== 'undefined' && window?.location?.hostname === 'localhost'
export const isC1Prod =
  typeof window !== 'undefined' &&
  window?.location?.hostname === 'cloudone.trendmicro.com'
